import { withType } from "../../../utils/actionOperations";
import { CHANGE_RENDER_TYPE, RENDER_PDF_SET_VALUE_AT_PATH } from "../../constants";

export const setValueAtPath = (path, value) => {
  return (dispatch) => {
    dispatch(withType(RENDER_PDF_SET_VALUE_AT_PATH, { path: path, value: value }));
  };
};


export const setReportType = (payload) => {
  return (dispatch) => {
    dispatch(withType(CHANGE_RENDER_TYPE, payload));
  };
}